import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3da72e73"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BtnCircle: require('/var/www/html/fantini/frontend-2/components/btn/circle/index.vue').default,VectorIcon: require('/var/www/html/fantini/frontend-2/components/vector/icon/index.vue').default,Spinner: require('/var/www/html/fantini/frontend-2/components/spinner/index.vue').default,ListItemOutOfProduction: require('/var/www/html/fantini/frontend-2/components/list/item/out-of-production/index.vue').default,ListItemProduct: require('/var/www/html/fantini/frontend-2/components/list/item/product/index.vue').default})
